/*
 * Onyu mega menu — hover-to-open for the category bar (snippets/onyu-mega-menu.liquid).
 * Works on top of Dawn's <header-menu> / <details> pattern (details-disclosure.js):
 *  - Mouse devices: open on hover (short intent delay), close on leave; clicking the
 *    top item goes to its department page.
 *  - Keyboard: Enter/Space toggles the panel as before; Escape is handled by global.js.
 *  - Touch / no-hover devices: unchanged tap-to-open (the panel has a "View all" link).
 */
(() => {
  const hoverQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
  const OPEN_DELAY = 80;
  const CLOSE_DELAY = 150;

  const menus = () => Array.from(document.querySelectorAll('.onyu-nav header-menu'));

  function setOpen(menu, open) {
    const details = menu.querySelector('details');
    const summary = details && details.querySelector('summary');
    if (!details || details.open === open) return;
    details.open = open; // fires 'toggle' → Dawn's HeaderMenu keeps the sticky header in place
    if (summary) summary.setAttribute('aria-expanded', String(open));
  }

  function init(menu) {
    if (menu.dataset.onyuHover) return;
    menu.dataset.onyuHover = 'true';
    const summary = menu.querySelector('summary');
    let timer;

    menu.addEventListener('mouseenter', () => {
      if (!hoverQuery.matches) return;
      clearTimeout(timer);
      timer = setTimeout(() => {
        menus().forEach((other) => other !== menu && setOpen(other, false));
        setOpen(menu, true);
      }, OPEN_DELAY);
    });

    menu.addEventListener('mouseleave', () => {
      if (!hoverQuery.matches) return;
      clearTimeout(timer);
      timer = setTimeout(() => setOpen(menu, false), CLOSE_DELAY);
    });

    if (summary) {
      summary.addEventListener('click', (event) => {
        // event.detail === 0 → keyboard activation: keep the normal toggle.
        if (!hoverQuery.matches || event.detail === 0 || !summary.dataset.href) return;
        event.preventDefault();
        window.location.href = summary.dataset.href;
      });
    }
  }

  function initAll() {
    menus().forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Theme editor re-renders the header section.
  document.addEventListener('shopify:section:load', initAll);
})();
